module.exports = __webpack_public_path__ + "static/media/img_snake_head_bottom.0450b21c.svg";